// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding-top: 5rem;
  background-color: #000000;
  flex-shrink: 0;
}
@media (max-width: 1679px) {
  .footer {
    padding-top: 4rem;
  }
}
@media (max-width: 767px) {
  .footer {
    padding-top: 2rem;
  }
}
@media (max-width: 991px) {
  .footer > .container .row {
    row-gap: 1.5rem;
  }
}
.footer .footer_in {
  max-width: 36.4rem;
}
@media (max-width: 575px) {
  .footer .footer_in {
    max-width: 100%;
  }
}
.footer .footer_in .logo {
  margin-bottom: 2rem;
}
@media (max-width: 575px) {
  .footer .footer_in .logo {
    margin-bottom: 1rem;
  }
}
@media (max-width: 767px) {
  .footer .footer_in .logo img {
    max-width: 15rem;
  }
}
@media (max-width: 575px) {
  .footer .footer_in .logo img {
    max-width: 12rem;
  }
}
.footer .footer_in p {
  color: #d1d1d1;
  font-weight: 300;
  line-height: 2.6rem;
}
@media (max-width: 991px) {
  .footer .footer_in p {
    line-height: 2rem;
  }
}
.footer .copyright {
  margin-top: 3.3rem;
  padding: 2rem 0;
  border-top: 0.1rem solid rgba(255, 255, 255, 0.2);
}
@media (max-width: 1679px) {
  .footer .copyright {
    margin-top: 2.5rem;
    padding: 1.5rem 0;
  }
}
@media (max-width: 575px) {
  .footer .copyright {
    margin-top: 1.5rem;
    padding: 1rem 0;
  }
}
.footer .copyright .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 575px) {
  .footer .copyright .container {
    gap: 1rem;
    flex-direction: column-reverse;
  }
}
.footer .copyright .container p {
  color: #ffffff;
}
@media (max-width: 575px) {
  .footer .copyright .container p {
    text-align: center;
  }
}
.footer .security,
.footer .exchnge_link {
  display: flex;
  justify-content: center;
}
@media (max-width: 575px) {
  .footer .security,
  .footer .exchnge_link {
    justify-content: flex-start;
  }
}
.footer .exchnge_link {
  justify-content: end;
}
@media (max-width: 991px) {
  .footer .exchnge_link {
    justify-content: flex-start;
  }
}

.social-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}
@media (max-width: 991px) {
  .social-links {
    gap: 1.5rem;
  }
}
@media (max-width: 575px) {
  .social-links {
    gap: 1rem;
  }
}
.social-links li a img {
  width: 3rem;
  height: 3rem;
  transition: all linear 0.2s;
}
.social-links li a img:hover {
  transform: scale(1.15);
}

.footer-links li:not(:last-child) {
  margin-bottom: 1rem;
}
@media (max-width: 575px) {
  .footer-links li:not(:last-child) {
    margin-bottom: 0.5rem;
  }
}
.footer-links li h6 {
  font-family: "Poppins", sans-serif;
  font-size: 1.8rem;
  line-height: 2.7rem;
  font-weight: 500;
  margin-bottom: 0.7rem;
}
@media (max-width: 1679px) {
  .footer-links li h6 {
    margin-bottom: 0.5rem;
    font-size: 1.6rem;
    line-height: 2.2rem;
  }
}
@media (max-width: 767px) {
  .footer-links li h6 {
    margin-bottom: 0.35rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
}
@media (max-width: 575px) {
  .footer-links li h6 {
    font-size: 1.3rem;
    margin-bottom: 0;
  }
}
.footer-links li a {
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 300;
  color: #d1d1d1;
  transition: all linear 0.2s;
}
@media (max-width: 1679px) {
  .footer-links li a {
    font-size: 1.4rem;
    line-height: 2rem;
  }
}
@media (max-width: 767px) {
  .footer-links li a {
    font-size: 1.2rem;
    line-height: 1.6rem;
  }
}
@media (max-width: 575px) {
  .footer-links li a {
    font-size: 1.1rem;
  }
}
.footer-links li a:not([href]):not([class]) {
  color: #d1d1d1;
}
.footer-links li a:hover {
  color: #6d8afa;
}
.footer-links .address p {
  color: #d1d1d1;
}
.footer-links .address p a {
  font-weight: 400;
}
.footer-links .address .add_link {
  font-weight: 500;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/Footer/Footer.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,yBCEM;EDDN,cAAA;AAAF;AAEE;EALF;IAMI,iBAAA;EACF;AACF;AACE;EATF;IAUI,iBAAA;EAEF;AACF;AACI;EACE;IACE,eAAA;EACN;AACF;AAGE;EACE,kBAAA;AADJ;AAGI;EAHF;IAII,eAAA;EAAJ;AACF;AAEI;EACE,mBAAA;AAAN;AAEM;EAHF;IAII,mBAAA;EACN;AACF;AAEQ;EADF;IAEI,gBAAA;EACR;AACF;AACQ;EALF;IAMI,gBAAA;EAER;AACF;AAEI;EACE,cCvCO;EDwCP,gBAAA;EACA,mBAAA;AAAN;AAEM;EALF;IAMI,iBAAA;EACN;AACF;AAGE;EACE,kBAAA;EACA,eAAA;EACA,iDAAA;AADJ;AAGI;EALF;IAMI,kBAAA;IACA,iBAAA;EAAJ;AACF;AAEI;EAVF;IAWI,kBAAA;IACA,eAAA;EACJ;AACF;AACI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACN;AACM;EALF;IAMI,SAAA;IACA,8BAAA;EAEN;AACF;AAAM;EACE,cChFA;ADkFR;AAAQ;EAHF;IAII,kBAAA;EAGR;AACF;AAEE;;EAEE,aAAA;EACA,uBAAA;AAAJ;AAEI;EALF;;IAMI,2BAAA;EAEJ;AACF;AACE;EACE,oBAAA;AACJ;AAAI;EAFF;IAGI,2BAAA;EAGJ;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;AAAE;EALF;IAMI,WAAA;EAGF;AACF;AADE;EATF;IAUI,SAAA;EAIF;AACF;AAAM;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AAER;AAAQ;EACE,sBAAA;AAEV;;AAOI;EACE,mBAAA;AAJN;AAMM;EAHF;IAII,qBAAA;EAHN;AACF;AAMI;EACE,kCCrJK;EDsJL,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAJN;AAMM;EAPF;IAQI,qBAAA;IACA,iBAAA;IACA,mBAAA;EAHN;AACF;AAKM;EAbF;IAcI,sBAAA;IACA,iBAAA;IACA,mBAAA;EAFN;AACF;AAIM;EAnBF;IAoBI,iBAAA;IAEA,gBAAA;EAFN;AACF;AAKI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cC1KO;ED2KP,2BAAA;AAHN;AAKM;EAPF;IAQI,iBAAA;IACA,iBAAA;EAFN;AACF;AAIM;EAZF;IAaI,iBAAA;IACA,mBAAA;EADN;AACF;AAGM;EAjBF;IAkBI,iBAAA;EAAN;AACF;AAEM;EACE,cC5LK;AD4Lb;AAGM;EACE,cCnME;ADkMV;AAOI;EACE,cCvMO;ADkMb;AAOM;EACE,gBAAA;AALR;AASI;EACE,gBAAA;EACA,cCrNE;AD8MR","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n.footer {\n  padding-top: 5rem;\n  background-color: $black;\n  flex-shrink: 0;\n\n  @media (max-width: 1679px) {\n    padding-top: 4rem;\n  }\n\n  @media (max-width: 767px) {\n    padding-top: 2rem;\n  }\n\n  >.container {\n    @media (max-width: 991px) {\n      .row {\n        row-gap: 1.5rem;\n      }\n    }\n  }\n\n  .footer_in {\n    max-width: 36.4rem;\n\n    @media (max-width: 575px) {\n      max-width: 100%;\n    }\n\n    .logo {\n      margin-bottom: 2rem;\n\n      @media (max-width: 575px) {\n        margin-bottom: 1rem;\n      }\n\n      img {\n        @media (max-width: 767px) {\n          max-width: 15rem;\n        }\n\n        @media (max-width: 575px) {\n          max-width: 12rem;\n        }\n      }\n    }\n\n    p {\n      color: $lightGray2;\n      font-weight: 300;\n      line-height: 2.6rem;\n\n      @media (max-width: 991px) {\n        line-height: 2rem;\n      }\n    }\n  }\n\n  .copyright {\n    margin-top: 3.3rem;\n    padding: 2rem 0;\n    border-top: 0.1rem solid rgba($white, 0.2);\n\n    @media (max-width: 1679px) {\n      margin-top: 2.5rem;\n      padding: 1.5rem 0;\n    }\n\n    @media (max-width: 575px) {\n      margin-top: 1.5rem;\n      padding: 1rem 0;\n    }\n\n    .container {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      @media (max-width: 575px) {\n        gap: 1rem;\n        flex-direction: column-reverse;\n      }\n\n      p {\n        color: $white;\n\n        @media (max-width: 575px) {\n          text-align: center;\n        }\n      }\n    }\n  }\n\n  .security,\n  .exchnge_link {\n    display: flex;\n    justify-content: center;\n\n    @media (max-width:575px) {\n      justify-content: flex-start;\n    }\n  }\n\n  .exchnge_link {\n    justify-content: end;\n    @media (max-width:991px) {\n      justify-content: flex-start;\n    }\n  }\n}\n\n.social-links {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n\n  @media (max-width: 991px) {\n    gap: 1.5rem;\n  }\n\n  @media (max-width: 575px) {\n    gap: 1rem;\n  }\n\n  li {\n    a {\n      img {\n        width: 3rem;\n        height: 3rem;\n        transition: all linear 0.2s;\n\n        &:hover {\n          transform: scale(1.15);\n        }\n      }\n    }\n  }\n}\n\n.footer-links {\n  li {\n    &:not(:last-child) {\n      margin-bottom: 1rem;\n\n      @media (max-width: 575px) {\n        margin-bottom: 0.5rem;\n      }\n    }\n\n    h6 {\n      font-family: $baseFont;\n      font-size: 1.8rem;\n      line-height: 2.7rem;\n      font-weight: 500;\n      margin-bottom: 0.7rem;\n\n      @media (max-width: 1679px) {\n        margin-bottom: 0.5rem;\n        font-size: 1.6rem;\n        line-height: 2.2rem;\n      }\n\n      @media (max-width: 767px) {\n        margin-bottom: 0.35rem;\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n      }\n\n      @media (max-width: 575px) {\n        font-size: 1.3rem;\n        // line-height: 1.5rem;\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      font-size: 1.6rem;\n      line-height: 2.4rem;\n      font-weight: 300;\n      color: $lightGray2;\n      transition: all linear 0.2s;\n\n      @media (max-width: 1679px) {\n        font-size: 1.4rem;\n        line-height: 2rem;\n      }\n\n      @media (max-width: 767px) {\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n      }\n\n      @media (max-width: 575px) {\n        font-size: 1.1rem;\n      }\n\n      &:not([href]):not([class]) {\n        color: $lightGray2;\n      }\n\n      &:hover {\n        color: $primary;\n      }\n    }\n  }\n\n  .address {\n    p {\n      color: $lightGray2;\n\n      a {\n        font-weight: 400;\n      }\n    }\n\n    .add_link {\n      font-weight: 500;\n      color: $white;\n    }\n  }\n}","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
